// Utility function to generate URL-friendly slugs from project titles
export const generateSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .trim(); // Remove leading/trailing whitespace
};

export const projects = [
  {
    id: 1,
    title: 'CoffeeStain frontend',
    slug: 'coffeestain-frontend',
    category: 'Frontend',
    date: '2025-12-31',
    status: 'Ongoing',
    technologies: ['AWS CDK', 'React', 'Typescript'],
    description: 'This website is a react frontend deployed with aws cdk.',
    detailedDescription: `
      <p>This website. It's ongoing.</p>
    `,
    links: [
      {
        type: 'github',
        label: 'Source Code',
        url: 'https://github.com/JakeDahl/coffeestain_website'
      }
    ],
    image: '🌐',
    featured: false
  },
  {
    id: 2,
    title: 'Forward Proxy Service',
    slug: 'forward-proxy-service',
    category: 'DevOps',
    date: '2025-08-30',
    status: 'Completed',
    technologies: ['Python', 'AWS CDK', 'API Gateway', 'Lambda', 'SQS', 'S3'],
    description: 'Forward proxy system with dynamic IP rotation for circumventing anti-scraping mechanisms. Features automated IP address rotation, event-driven updates, and scalable AWS serverless architecture.',
    detailedDescription: `
      <p>The Forward Proxy Service is a sophisticated serverless solution designed to provide dynamic IP rotation capabilities for web scraping and API requests. Built entirely on AWS infrastructure using CDK (Cloud Development Kit), this system automatically rotates IP addresses to circumvent anti-scraping mechanisms and rate limiting.</p>
      
      <p>The system operates as an intelligent intermediary between client applications and target servers, automatically injecting randomized US-based IP addresses into HTTP headers to mask the true origin of requests. This approach is particularly effective for:</p>
      
      <ul>
        <li><strong>Web Scraping Operations</strong> - Bypass IP-based rate limits and blocks</li>
        <li><strong>API Testing</strong> - Test geolocation-dependent endpoints</li>
        <li><strong>Load Distribution</strong> - Distribute requests across multiple apparent sources</li>
        <li><strong>Anti-Detection</strong> - Avoid pattern recognition systems</li>
      </ul>
      
      <p>The service leverages AWS API Gateway as the primary entry point, with Lambda functions handling the intelligent IP rotation logic. All configuration is managed through S3-stored JSON files, enabling dynamic proxy target management without code changes.
      
      This service has been particularly useful in performing mass web-scraping against sports betting platforms.</p>
    `,
    images: [
      {
        src: '/ProxyService.drawio.png',
        alt: 'Forward Proxy Service Architecture Diagram',
        caption: 'Complete system architecture showing AWS components and data flow'
      },
    ],
    links: [
      {
        type: 'github',
        label: 'Source Code',
        url: 'https://github.com/JakeDahl/ProxyService'
      }
    ],
    image: '🌐',
    featured: false
  },
  {
    id: 3,
    title: '"Apex Legends" ESP + Aimbot',
    slug: 'apex-legend-esp',
    category: 'Reverse Engineering',
    date: '2019-05-30',
    status: 'Completed',
    technologies: ['C++', 'IDA Pro', 'DirectX'],
    description: 'Video game cheat for the "Apex Legends" game. ESP + Aimbot with smooth aiming and bullet drop compensation.',
    detailedDescription: `
      <p>An apex legends ESP (see players through walls) with a custom directx overlay for the game. Also contains an aimbot which has smooth aiming and bullet drop compensation features.</p>
      <p>Uses a windows kernel driver to interface with the game.</p>
      <p>Uses complex math to calculate angles and calculations for the aimbot and ESP.</p>
      <p>Project has over 40 stars on github.</p>
    `,
    links: [
      {
        type: 'github',
        label: 'Source Code',
        url: 'https://github.com/JakeDahl/ApexStuff'
      },
      {
        type:'demo',
        label: 'Live Demo',
        url: 'https://www.youtube.com/watch?v=mAuf1m5aKQI'
      }
    ],
    image: '+',
    featured: false
  },
  {
    id: 4,
    title: '"DayZ" ESP + Speedhack',
    slug: 'dayz-external-esp',
    category: 'Reverse Engineering',
    date: '2019-05-30',
    status: 'Completed',
    technologies: ['C++', 'IDA Pro', 'DirectX'],
    description: 'Video game cheat for the "DayZ" video game. ESP for Players, Items, tents, other objects. Speedhack allowed the user to move beyond normal rate of movement.',
    detailedDescription: `
      <p>A DayZ ESP (see players through walls) with a custom directx overlay for the game. Contains a speedhack as well by modifying the game tick by writing to a pointer.</p>
      <p>Uses a windows kernel driver to interface with the game.</p>
      <p>Uses complex math to calculate angles and calculations for the ESP.</p>
    `,
    links: [
      {
        type: 'github',
        label: 'Source Code',
        url: 'https://github.com/JakeDahl/ExternalDayZ'
      },
      {
        type:'demo',
        label: 'Live Demo',
        url: 'https://www.youtube.com/watch?v=hy0vWpF1wv4'
      }
    ],
    image: '👟',
    featured: false
  },
  {
    id: 5,
    title: 'ArmA: 3 Cheat',
    slug: 'arma-internal-hack',
    category: 'Reverse Engineering',
    date: '2019-07-30',
    status: 'Completed',
    technologies: ['C++', 'IDA Pro', 'Windows Kernel'],
    description: 'An "internal" DLL cheat for a video game called "ArmA 3" which is injected into the running video game. Delivered many features on top of the game to enhance gameplay.',
    detailedDescription: `
      <p>A sophisticated hack for the Arma 3 video game. Written entirely in C++, the software utilizes a DirectX 11 "present" hook to hook the game's thread and run a video game cheat in-sync with the rendered visuals.
      Uses memory hooking and dereferencing techniques to implement the following features:</p>

      <ul>
        <li>Player, Vehicle, AI ESP with distance. DirectX 11 hook to render in game using a Virtual Method Table (VMT) hook. Then wrote a renderer to use the swapchain pointer captured from the hook to draw onscreen visuals.</li>
        <li>No clip (Flying & traveling through walls) & Teleporting</li>
        <li>Remote unlocking of others vehicles.</li>
        <li>Super strong, near invincible vehicles.</li>
        <li>Teleporting of bullets</li>
        <li>Spoofing of other player</li>
      </ul>

      <p>Conducted reverse engineering with IDA Pro and various static and dynamic analysis tools, and developed pattern scanning based automation to maintain the software through reverse engineering methods.</p>
      
    `,
    challenges: 'Developing effective anti-cheat circumvention method.',
    detailedChallenges: `
      <p>Since this is a DLL based cheat, developing a means to inject the payload into the target while circumventing the anti-cheat software was difficult. It required building a windows kernel based driver which hijacked a thread and manual mapped a DLL into it.</p>
    `,
    // images: [
    //   {
    //     src: '/ProxyService.drawio.png',
    //     alt: 'Forward Proxy Service Architecture Diagram',
    //     caption: 'Complete system architecture showing AWS components and data flow'
    //   },
    // ],
    links: [
      {
        type: 'github',
        label: 'Source Code',
        url: 'https://github.com/JakeDahl/Arma3Internal/'
      },
      {
        type:'demo',
        label: 'Live Demo (Language Warning, loud kid)',
        url: 'https://www.youtube.com/watch?v=ivUCjKG8kC4'
      }
    ],
    image: '🎯',
    featured: false
  },
  {
    id: 6,
    title: '"Osu!" Hardware Ban Bypass',
    slug: 'osu-bypass',
    category: 'Reverse Engineering',
    date: '2019-05-30',
    status: 'Completed',
    technologies: ['C++', 'IDA Pro', 'DnSpy'],
    description: 'A DLL for a video game called "Osu!" which is used to circumvent hardware-id (HWID) based bans from the game.',
    detailedDescription: `
      <p>Circumvents HWID bans on osu without tampering with any windows settings. Also inadvertently removes the need to validate your email.</p>
      <p>Sets a detour (mid-function hook) on:</p>
      <ul>
        <li><strong>DetourShellExecuteExW</strong>: For automating a UI feature for automatically downloading a beatmap without a pro-subscription.</li>
        <li><strong>DetourGetAdaptersAddresses</strong>: Hooked to return "ERROR_NO_DATA" value, since the game uses adapter addresses as part of the HWID.</li>
        <li><strong>DetourRegQueryValueExW</strong>: Hooked to return "ERROR_FILE_NOT_FOUND" when the game queries for your "UninstallID" or your "CurrentBuildNumber".</li>
      </ul>
      <strong>By implementing the above hooks, it allows you to circumvent a hardware-id ban (sans DetourShellExecuteExW, which is an added feature)</strong>

    <h5>Requires special launcher, which does the following:</h5>
    <p><strong>1. </strong>Game is launched by custom launcher in suspended state (CreateProcess with CREATE_SUSPENDED flag)</p>
    <p><strong>2. </strong>Osu-Bypass mapped into game (I use a manual map via thread hijacking to load my code). </p>
    <p><strong>3. </strong>Launcher resumes all threads. </p>

    The hooks are installed before the HWID is taken by doing this therefore allowing you to play.</p>

    `,
    links: [
      {
        type: 'github',
        label: 'Source Code',
        url: 'https://github.com/JakeDahl/Osu-Bypass'
      },
    ],
    image: '🎵',
    featured: false
  },
  {
    id: 7,
    title: '"Plant Scanner" BLE scanner app',
    slug: 'plant-scanner',
    category: 'iOS App',
    date: '2025-09-08',
    status: 'Ongoing',
    technologies: ['Swift'],
    description: 'A iOS app for scanning your surroundings for bluetooth low energy. Includes a bytes decoder feature so and device labeling feature.',
    detailedDescription: `
      <p>Useful for IoT related tasks.</p>
      <p>Link coming soon.</p>
    `,
    images: [
      {
        src: '/plantscannerpics/plant-scanner-temp.png',
        alt: 'Plant Scanner displaying a temperature sensor value',
        caption: '"Plant Scanner" displaying a temperature sensor value by deriving it with a math function.'
      },
    ],
    links: [
    ],
    image: ' 📱',
    featured: false
  },
  {
    id: 8,
    title: 'Dreambot Scripting MCP',
    slug: 'dreambot-mcp',
    category: 'GenAI',
    date: '2025-09-08',
    status: 'Completed',
    technologies: ['Python', 'MCP'],
    description: 'An MCP for Dreambot scripting.',
    detailedDescription: `
      <p>Parses and reads the javadocs for Dreambot, a runescape bot. Since it parses the javadocs, it adds the dreambot specific knowledge in a tool-use pattern for AI coding agents to use.</p>
    `,
    images: [
    ],
    links: [
        {
        type: 'github',
        label: 'Source Code',
        url: 'https://github.com/JakeDahl/Dreambot-Scripting-MCP'
      },
    ],
    image: ' 🤖',
    featured: false
  },
];

export const categories = ['all', 'DevOps', 'Reverse Engineering', 'Frontend', 'iOS App', 'GenAI'];
